import { ReactNode, useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useRouter } from 'next/router';
import EfLink from 'elem/ui/ef-link';
import { signupCookie } from 'eco-design-reliance/cookies/signupCookie';
import EcoButton from 'eco-design/base/eco-button';
import { useReferralStore, useReferralDispatch } from '../../ReferralProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EfModal from '@/components/UI/Modal';
import LoginFormModal from '@/components/LoginFormModal';
import getLocal from '@/app/utils/getLocal';
import Button from '@/components/UI/Button';

interface ReferButtonProps {
    /** 按钮主题 */
    lTheme?: 'white' | 'black';
    /** 按钮圆角 */
    lRadius?: 'ellipse';
    /** 自定义按钮文案，不传则使用默认文案 */
    children?: ReactNode;
    /** 自定义 className */
    className?: string;
    /** entry_position 用于 signupCookie */
    entryPosition?: number;

    codeState: string;

    bannerTitle: string;
}

export default function ReferButton({
    lTheme = 'white',
    lRadius = 'ellipse',
    codeState,
    className,
    bannerTitle,
    entryPosition = 1,
    children,
}: ReferButtonProps) {
    const { t } = useLang('referral');
    const { locale } = getLocal();

    const { inBlackList, isLogin, actStatus } = useReferralStore();
    const dispatch = useReferralDispatch();

    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isClient, setIsClient] = useState(false);
    const [show, setShow] = useState(false);

    const router = useRouter();

    const toRegisterPage = (text: string) => {
        if (isLogin) {
            // 跳转邀请页
            window.location.href = `/${locale}/referral?pop=share`;
            return;
        }
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'referral_button',
                position: 'Gifts Await You!',
                button_name: t('banner.btn'),
            });
        } catch (e) {
            console.log(e);
        }
        if (actStatus === 1) {
            signupCookie({ sector_name: bannerTitle, entry_position: 1 });
            location.href = `/${locale}/register?inviteCode=${router.query.inviteCode}&redirect=${encodeURIComponent(
                `https://${locale}.ecoflow.com/pages/prime-day`,
            )}`;
            return;
        }
        if (codeState === '2442') setShow(true);
        if (codeState !== '0') return;
        signupCookie({ sector_name: bannerTitle, entry_position: 1 });
        setShowLoginModal(true);
    };

    const handleLoginSuccess = () => {
        setShowLoginModal(false);
        // 更新登录状态
        dispatch({ type: 'changeIsLogin', payload: true });
        setTimeout(() => {
            // referRef.current?.show();
        }, 100);
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const onCloseGtm = (btnName: string) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'popup_close',
                title_name: t('invitation_tips_title'),
                button_name: btnName,
            });
        } catch (e) {
            console.log(e);
        }
    };

    return (
        <>
            <EcoButton lRadius={lRadius} lTheme={lTheme} disabled={inBlackList} onClick={toRegisterPage} className={className}>
                {children || t('banner.btn')}
            </EcoButton>

            {isClient &&
                showLoginModal &&
                createPortal(
                    <LoginFormModal
                        visible={showLoginModal}
                        onCancel={() => {
                            setShowLoginModal(false);
                        }}
                        onSuccess={handleLoginSuccess}
                        type="passwordless"
                    />,
                    document.body,
                )}

            <EfModal
                width="560"
                visible={show}
                open={show}
                className={`${styles.no_active_modal}`}
                centered={true}
                getContainer={true}
                onCancel={() => {
                    setShow(false);
                    onCloseGtm('Close');
                }}
            >
                <div className="content">
                    <h5 className="title">{t('invitation_tips_title')}</h5>
                    <p className="msg">{t('invitation_tips_cotent')}</p>
                    <div className="tools">
                        <Button
                            className="btn later"
                            onClick={() => {
                                setShow(false);
                                onCloseGtm('Later');
                            }}
                        >
                            {t('invitation_tips_cancel')}
                        </Button>
                        <EfLink
                            onClick={() => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'jump_button',
                                    position: 'Pop-up Reminder',
                                    button_name: t('invitation_tips_confirm'),
                                    url: '',
                                });
                                setShow(false);
                                setShowLoginModal(true);
                            }}
                        >
                            <Button className="btn">{t('invitation_tips_confirm')}</Button>
                        </EfLink>
                    </div>
                </div>
            </EfModal>
        </>
    );
}
